import { Middleware, isAction, UnknownAction, isAsyncThunkAction } from '@reduxjs/toolkit';
import { get } from '@direct-frontend/stdlib';
import { UnexpectedError } from '@adv-frontend/error';

function filterAction(action: UnknownAction) {
    return (
        isAsyncThunkAction(action) &&
        action.meta.requestStatus === 'rejected' &&
        !action.meta.condition &&
        !action.meta.rejectedWithValue &&
        !action.meta.aborted
    );
}

export const handleErrorMiddleware: Middleware = () => next => action => {
    const returnValue = next(action);
    if (isAction(action) && filterAction(action)) {
        const error = new UnexpectedError('Unexpected thunk rejection', {
            cause: get(action, ['error']),
            additional: {
                arg: get(action, ['meta', 'arg']),
            },
            groupBy: {
                thunk: action.type.replace('/rejected', ''),
            },
        });

        if (process.env.BUILD_TARGET === 'server') {
            process.emit('unhandledRejection', error, Promise.resolve(error));
        } else {
            const unhandledRejectionEvent = new PromiseRejectionEvent('unhandledrejection', {
                promise: Promise.resolve(action),
                reason: error,
            });

            global.dispatchEvent(unhandledRejectionEvent);
        }
    }
    return returnValue;
};
